import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class TennantResolverService {

    resolve(activatedRoute: ActivatedRoute): string {
        const fromParam = activatedRoute.snapshot.paramMap.get('tenantId');
        if (fromParam) {
            return fromParam;
        }

        const firstUrlSeg = activatedRoute.snapshot.url?.length ? activatedRoute.snapshot.url[0].path : '';
        if (firstUrlSeg) {
            return firstUrlSeg;
        }

        const fromQuery = activatedRoute.snapshot.queryParamMap.get('tenantId');
        if (fromQuery) {
            return fromQuery;
        }

        try {
            const topPath = (window.top || window).location.pathname || '';
            const segments = topPath.split('/').filter(Boolean);
            if (segments.length) {
                return segments[0];
            }
        } catch {
            const selfPath = window.location.pathname || '';
            const segments = selfPath.split('/').filter(Boolean);
            if (segments.length) {
                return segments[0];
            }
        }

        return '';
    }
}


